import { useState } from "react";
import { KeyRound, Loader2 } from "lucide-react";
import api from "@/lib/api";
import { toast } from "sonner";

const inputCls = "w-full bg-[#0A0B0E] border border-[#282C37] rounded-lg px-3 py-2 text-amber-50 focus:border-[#D4AF37] focus:outline-none font-sans2 text-sm";

export default function AccountSecurityTab({ embedded = false }) {
  const [form, setForm] = useState({ current_password: "", new_password: "", confirmation: "" });
  const [saving, setSaving] = useState(false);

  const changePassword = async (event) => {
    event.preventDefault();
    if (form.new_password !== form.confirmation) {
      toast.error("A confirmação da nova senha não confere.");
      return;
    }
    setSaving(true);
    try {
      await api.post("/auth/change-password", {
        current_password: form.current_password,
        new_password: form.new_password,
      });
      setForm({ current_password: "", new_password: "", confirmation: "" });
      toast.success("Senha alterada com sucesso.");
    } catch (error) {
      toast.error(error?.response?.data?.detail || "Não foi possível alterar a senha.");
    } finally {
      setSaving(false);
    }
  };

  return <section className="fade-in max-w-2xl">
    {!embedded && <><h1 className="font-display text-3xl gold-text">Minha conta</h1><p className="mt-2 text-sm text-stone-400 font-sans2">Altere sua senha de acesso à administração.</p></>}
    <form onSubmit={changePassword} className={`card-surface p-5 space-y-4 ${embedded ? "" : "mt-6"}`}>
      <h2 className="flex items-center gap-2 font-sans2 font-semibold text-amber-50"><KeyRound className="w-5 h-5 text-[#D4AF37]" /> Segurança</h2>
      <Field label="Senha atual"><input data-testid="current-password-input" required type="password" autoComplete="current-password" value={form.current_password} onChange={(event) => setForm({ ...form, current_password: event.target.value })} className={inputCls} /></Field>
      <Field label="Nova senha"><input data-testid="new-password-input" required type="password" minLength="12" autoComplete="new-password" value={form.new_password} onChange={(event) => setForm({ ...form, new_password: event.target.value })} className={inputCls} /></Field>
      <Field label="Confirmar nova senha"><input data-testid="confirm-password-input" required type="password" minLength="12" autoComplete="new-password" value={form.confirmation} onChange={(event) => setForm({ ...form, confirmation: event.target.value })} className={inputCls} /></Field>
      <p className="text-xs text-stone-500">A nova senha deve ter pelo menos 12 caracteres.</p>
      <button data-testid="change-password-button" disabled={saving} className="inline-flex items-center gap-2 rounded-lg bg-[#D4AF37] px-4 py-2.5 text-sm font-semibold text-[#0A0B0E] disabled:opacity-60">
        {saving && <Loader2 className="w-4 h-4 animate-spin" />} Alterar senha
      </button>
    </form>
  </section>;
}

function Field({ label, children }) {
  return <label className="block text-sm text-stone-300 font-sans2">{label}<span className="mt-1.5 block">{children}</span></label>;
}
